module.exports = __webpack_public_path__ + "img/mobilepainpoint3.7f10a11b.png";